<!-- DisponibilitaAccordion.vue -->
<template>
  <div>
    <div v-if="disponibilitaGrouped && Object.keys(disponibilitaGrouped).length">
      <div class="accordion" id="mainAccordion">
        <div v-for="(fasce, data) in disponibilitaGrouped" :key="data">
          <div class="accordion-item" v-if="Array.isArray(fasce) && fasce.length && data">
            <!-- Header -->
            <h2 class="accordion-header" :id="'heading' + data">
              <button
                  class="accordion-button collapsed"
                  type="button"
                  @click="toggleCollapse(data)"
              >
                {{ giornoSettimana[fasce[0]?.giornoSettimana] || 'Giorno non valido' }} - {{ formatData(data) }}
              </button>
            </h2>

            <!-- Body -->
            <div
                :id="'collapse' + data"
                class="accordion-collapse collapse"
                :class="{ 'show': activeItem === data }"
            >
              <div class="accordion-body">
                <ul class="list-unstyled mb-0">
                  <li v-for="(item, index) in fasce" :key="index" class="py-2 border-bottom">
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        Orario:
                        <span class="d-inline fw-medium">
                          {{ formatTime(item.oraInizio) }} - {{ formatTime(item.oraFine) }}
                        </span>
                      </div>
                      <div>
                        Tutor:
                        <span
                            class="d-inline user-name fw-medium"
                            @click="openUserProfile(item.utente?.id)"
                        >
                          {{ item.utente?.nome }} {{ item.utente?.cognome }}
                        </span>
                      </div>
                      <button
                          class="btn btn-sm btn-success"
                          @click="$emit('prenota', item)"
                      >
                        Prenota
                      </button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="isLoading" class="text-center">
      <div class="spinner-border text-muted"></div>
    </div>
    <div v-else>
      <p>Non sono presenti disponibilità per questa materia.</p>
    </div>

    <!-- User Profile Modal -->
    <div
        class="modal fade"
        id="userProfileModal"
        tabindex="-1"
        aria-labelledby="userProfileModalLabel"
        aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="userProfileModalLabel">Profilo Utente</h5>
            <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <UserProfile
                v-if="selectedUserId"
                :userId="selectedUserId"
                :is-own-profile="false"
                :student="false"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserProfile from './UserProfile.vue';
import { ref } from 'vue';
import { Modal } from 'bootstrap';
import moment from 'moment';

export default {
  name: 'DisponibilitaAccordion',
  components: {
    UserProfile
  },
  props: {
    disponibilitaGrouped: Object,
    giornoSettimana: Array,
    isLoading: Boolean,
    currentUserId: Number
  },
  setup() {
    const selectedUserId = ref(null);
    const activeItem = ref(null);

    return {
      selectedUserId,
      activeItem
    };
  },
  methods: {
    formatData(data) {
      return moment(data).format('DD-MM-YYYY');
    },
    formatTime(timeString) {
      const parts = timeString.split(':');
      return `${parts[0]}:${parts[1]}`;
    },
    openUserProfile(userId) {
      if (!userId) return;
      this.selectedUserId = userId;
      new Modal(document.getElementById('userProfileModal')).show();
    },
    toggleCollapse(data) {
      // Toggle activeItem
      this.activeItem = this.activeItem === data ? null : data;

      // Update button states
      const clickedButton = document.querySelector(`#heading${data} .accordion-button`);
      const allButtons = document.querySelectorAll('.accordion-button');

      allButtons.forEach(button => {
        button.classList.add('collapsed');
      });

      if (this.activeItem) {
        clickedButton.classList.remove('collapsed');
      }
    }
  },
  emits: ['prenota']
}
</script>

<style>
.accordion-collapse {
  display: block !important;
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);
}

.accordion-header button {
  color: black;
}

.accordion-collapse.show {
  max-height: 2000px;
  transition: max-height 1s ease-in-out;
}

.accordion-button {
  padding: 1rem;
  position: relative;
}

.accordion-button::after {
  flex-shrink: 0;
  width: 1.25rem;
  height: 1.25rem;
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: 1.25rem;
  transition: transform .2s ease-in-out;
}

.accordion-button:not(.collapsed)::after {
  transform: rotate(-180deg);
}

.accordion-button.collapsed::after {
  transform: rotate(0deg);
}
</style>

<style scoped>
.user-name {
  cursor: pointer;
  color: white;
  text-decoration: underline;
}

.user-name:hover {
  color: #0a58ca;
}

.accordion-body {
  padding: 1rem;
}

.list-unstyled li:last-child {
  border-bottom: none !important;
}
</style>